import { render, staticRenderFns } from "./StaScore.vue?vue&type=template&id=2d8ed549&scoped=true&"
import script from "./StaScore.vue?vue&type=script&lang=js&"
export * from "./StaScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8ed549",
  null
  
)

export default component.exports